import React, { Component } from 'react';
import cookie from 'react-cookies';
import axios from 'axios';
import './RAEstimateBox.css';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import Config from '../Configs/criteria.json';

    const options_rating = {
        "title": {
            "text": ""
        },
        "subtitle": {
            "text": ""
        },
        "exporting": {
            "enabled": false
        },
        "chart": {
            "type": "column",
            "polar": false,
            "width": 170,
            "height": 160
        },
        "plotOptions": {
            "series": {
            "pointPadding": 0,
            "groupPadding": 0,
            "borderWidth": 0,
            "shadow": false,
            "dataLabels": {
                "enabled": true
            },
            "animation": false,
            "colorByPoint": true,
            }
        },
        "series": [
            {
            "colorByPoint": true,
            }
        ],
        "tooltip": {
            "enabled": false,
            "shared": false
        },
        "yAxis": {
            "title": {
            "text": ""
            },
            "labels": {
            "format": " "
            },
            "type": "linear",
            "reversed": false
        },
        "xAxis": {
            "title": {
            "text": ""
            },
            "labels": {
            "format": "{value}"
            },
            "type": "category",
            "opposite": false,
            "reversed": false
        },
        "legend": {
            "floating": false,
            "enabled": false
        },
        "credits": {
            "enabled": false
        },
        "lang": {
            "thousandsSep": ","
        }
    }

    const options_estimate = {
        "title": {
          "text": ""
        },
        "subtitle": {
          "text": " "
        },
        "exporting": {
          "enabled": false
        },
        "chart": {
          "type": "column",
          "polar": false,
          "width": 170,
          "height": 169,
          "style": {
            "fontFamily": "\"HiraKakuPro\", \"Lucida Grande\", \"Lucida Sans Unicode\", Verdana, Arial, Helvetica, sans-serif",
            "color": "#333",
            "fontSize": "11px",
            "fontWeight": "normal",
            "fontStyle": "normal"
          }
        },
        "yAxis": {
          "title": {
            "text": ""
          },
          "labels": {}
        },
        "series": [
          {
            "name": "",
            "turboThreshold": 0,
            "marker": {
              "enabled": false
            }
          }
        ],
        "plotOptions": {
            "column": {
                "colorByPoint": true
            },
          "series": {
            "animation": false,
            "dataLabels": {
                "allowOverlap": true,
              "enabled": false
            }
          }
        },
        "xAxis": {
          "title": {
            "style": {
              "fontFamily": "\"HiraKakuPro\", \"Lucida Grande\", \"Lucida Sans Unicode\", Verdana, Arial, Helvetica, sans-serif",
              "color": "#666666",
              "fontSize": "12px",
              "fontWeight": "normal",
              "fontStyle": "normal"
            }
          },
          "labels": {
            style: {
                color: '#666666',
                fontSize:'8px'
            }
          },
          "type": "category"
        },
        "legend": {
          "enabled": false
        },
        "tooltip": {},
        "credits": {
          "enabled": false
        },
        "lang": {
            "thousandsSep": ","
        }
    }    

export default class RAEstimateBox extends Component {
    constructor(props) {
        super(props);
        Highcharts.setOptions({
            lang: {
              thousandsSep: ','
          }
        })
        this.tabletitle = [];
        this.tabletitle[0] = ["","平均スコア"];
        this.tabletitle[1] = ["年度","売上高<br/>(百万円)"];
        this.tabletitle[2] = ["年度","経常利益<br/>(百万円)"];
        this.tabletitle[3] = ["年度","当期利益<br/>(百万円)"];
        this.tabletitle[4] = ["年度","PER(倍)"];

        this.ratingcolumn = [];
        this.ratingcolumn[0] = "現在";
        this.ratingcolumn[1] = "1ヶ月前";
        this.ratingcolumn[2] = "2ヶ月前";
        this.ratingcolumn[3] = "6ヶ月前";
        this.ratingcolumn[4] = "12ヶ月前";

        this.state = {
            ric: "",
            symbol: "",
            name: "",
            market: "",
            sector: "",
            change: "",
            pctchange: "",
            tradetime: "",
            figures: [],
            modifiers: [],
            periods: [],
            brating: [],
            subtype: this.props.type,
            chartoptions_rating: options_rating,
            chartoptions_estimate: options_estimate,
            ec:"",
            rec:""
        };
    }
    getEstimateData = () => {
        axios.get("detail", {
            params: {
                ric: this.props.ric,
                type: 1,
                subtype: this.props.type,
                fid: 0,
                token: this.props.token
            }
        })
        .then(
            (result) => {
                if (result.data) {
                    // let chartoptions;
                    // chartoptions = options_rating;
                    // chartoptions.series = [{"data": [["弱気", result.data.charts[0]?result.data.charts[0].chartY[4]:0], ["やや弱気", result.data.charts[0]?result.data.charts[0].chartY[3]:0], ["中立", result.data.charts[0]?result.data.charts[0].chartY[2]:0], ["やや強気", result.data.charts[0]?result.data.charts[0].chartY[1]:0], ["強気", result.data.charts[0]?result.data.charts[0].chartY[0]:0]]}];
                    let series_rating = {series: [{"data": [["弱気", result.data.charts[0]?result.data.charts[0].chartY[4]:0], ["やや弱気", result.data.charts[0]?result.data.charts[0].chartY[3]:0], ["中立", result.data.charts[0]?result.data.charts[0].chartY[2]:0], ["やや強気", result.data.charts[0]?result.data.charts[0].chartY[1]:0], ["強気", result.data.charts[0]?result.data.charts[0].chartY[0]:0]]}]};
                    let est_data = [];
                    let colors=[];
                    for (let i=0; i<result.data.figures.length; i++) {
                        let x = "";
                        if (result.data.periods[i]) {
                            let d = new Date(result.data.periods[i]);
                            x = this.formatDate(d) + (result.data.modifiers[i]?"("+result.data.modifiers[i]+")":"");
                        }
                        colors[result.data.figures.length-i-1]=result.data.modifiers[i]?"#547BA1":"#7cb5ec"
                        est_data[result.data.figures.length-i-1] = [x, parseFloat(result.data.figures[i].toFixed(1))];
                    }
                    let series_estimate = {series: [{"data": est_data}],colors:colors};
                    this.setState({
                        ric: this.props.ric,
                        symbol: result.data.basicdata.code,
                        name: result.data.basicdata.name,
                        market: result.data.basicdata.market,
                        sector: result.data.basicdata.sector,
                        tradeprice: result.data.basicdata.TRDPRC_1,
                        change: result.data.basicdata.NETCHNG_1,
                        pctchange: result.data.basicdata.PCTCHNG,
                        tradetime: result.data.basicdata.TRDTIM_1,
                        figures: result.data.figures,
                        modifiers: result.data.modifiers,
                        periods: result.data.periods,
                        ec:result.data.basicdata.sbiExchangeCode,
                        rec:result.data.basicdata.exchangeCode
                        
                    });
                    if (this.props.type==="0") {
                        this.setState({
                            chartoptions_rating: series_rating
                        })
                    } else {
                        this.setState({
                            chartoptions_estimate: series_estimate
                        })
                    }
                }
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
            }
        )
    }
    genDataRow = () => {
        let result = [];
        for (let i=0; i<5; i++) {
            let td = [];
            if (this.state.periods[i]) {
                let d = new Date(this.state.periods[i]);
                td.push(<th>{this.formatDate(d)}{this.state.modifiers[i]?"("+this.state.modifiers[i]+")":""}</th>);
            } else if (this.props.type==="0") {
                td.push(<th>{this.ratingcolumn[i]}</th>);
            } else {
                td.push(<th>---</th>);
            }
            if (this.state.figures[i]) {
                td.push(<td>{this.formatNumber(this.state.figures[i], 1)}</td>);
            } else {
                td.push(<td>---</td>);
            }
            result.push(<tr>{td}</tr>);
        }
        return result;
    }
    componentDidMount() {
        this.getEstimateData();
    }
    componentDidUpdate() {
        if ((this.state.ric!=="" && this.props.ric!==this.state.ric) || (this.state.subtype!==this.props.type)) {
            this.setState({ ric: this.props.ric, subtype: this.props.type }, () => { this.getEstimateData(); })
        }
    }
    formatNumber = (val, dp) => {
        if (val){
            if (typeof val !== 'number') {
                val = parseFloat(val.replace(/,/g, ''));
            }
            if (dp) {
                val = new Intl.NumberFormat('en-GB', { 
                    minimumFractionDigits: dp, 
                    maximumFractionDigits: dp
                }).format(val);
            } else {
                val = new Intl.NumberFormat('en-GB').format(val);
            }
            return val;
        } else {
            return '-';
        }
    }
    formatPercentage = (val) => {
        if (val){
            if (typeof val !== 'number') {
                val = parseFloat(val.replace(/,/g, ''));
            }
            return new Intl.NumberFormat('en-GB', { 
                style: 'percent',
                minimumFractionDigits: 2, 
                maximumFractionDigits: 2
            }).format(val);
        } else {
            return '-'
        }
    }
    formatDate = (d) => {
        if (d) {
            return d.toLocaleString("en-us", {year: 'numeric'}) + '/' + d.toLocaleString("en-us", {month: '2-digit'});
        } else {
            return '-';
        }
    }
    millisToHoursAndMinutes = (millis) => {
        if (millis) {
            var hours = Math.floor(millis / 60000 / 60);
            var minutes = ((millis / 60000) % 60);
            // var seconds = ((millis % 60000) / 1000).toFixed(0);
            return (minutes === 60 ? (hours+1) + ":00" : hours + ":" + (minutes < 10 ? "0" : "") + minutes);
        } else {
            return '-';
        }
    }
    handleAddTo = (code,exchangeCode,rexchangeCode) => (e) => {
        let url =this.props.appId==="Hyper"?Config.hyperdomain+"/5907/"+rexchangeCode+"/"+code : Config.domain+"/ETGate/?_ControlID=WPLETpfR001Control&_PageID=WPLETpfR001Eins13&_DataStoreID=DSWPLETpfR001Control&getFlg=on&_ActionID=viewPf&src_web_sec_code=" + code + "&src_sec_id=ST&src_market_id="+rexchangeCode+"&link_url=%2FETGate%2F%3F_ControlID%3DWPLETsqR001Control%26amp%3B_DataStoreID%3DDSWPLETsqR001Control%26amp%3B_PageID%3DWPLETsqR001Sdtl10%26amp%3BgetFlg%3Don%26amp%3B_ActionID%3DDefaultAID%26amp%3Bi_stock_sec%3D4307%26amp%3Bcat1%3Ddomestic%26amp%3Bcat2%3Dinfo%26amp%3Bsec_code%3D4307%26amp%3Bexchange_code%3D"+exchangeCode+"%26amp%3Bi_exchange_code%3DJPN&OutSide=on";
        window.open(url, this.props.appId==="Hyper"?"_self":"_blank"); 
    }
    render() {
        const { symbol, name, market, tradeprice, change, pctchange, tradetime,ec,rec } = this.state;
        return (
            <div className="RAEstimateBox">
                <table className="detailTable">
                    <tbody>
                        <tr >
                        <td className="stock" colSpan="3">
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', height: '34px', alignItems: 'center' }}>
                                    <div><span className="stockcode">{symbol}</span>
                                <span className="stockname"><a href={this.props.appId==="Hyper"?Config.hyperdomain+"/1004/"+ec+"/"+symbol :Config.domain+"/ETGate/?_ControlID=WPLETsiR001Control&_PageID=WPLETsiR001Idtl10&_DataStoreID=DSWPLETsiR001Control&_ActionID=stockDetail&stock_sec_code_mul=" + symbol + "&exchange_code="+ec+"&i_dom_flg=1&i_output_type=0&getFlg=on&OutSide=on&"} rel="noopener noreferrer" target={this.props.appId==="Hyper"?"_self":"_blank"}>{name}</a></span>
                                </div>
                                    <div>
                                <span className="categorybox">{market}</span>
                                <span className="addto" onClick={this.handleAddTo(symbol,ec,rec)}>追加</span>
                                </div>
                                </div>
                            </td> 
                        </tr>
                        <tr>  

                            <td className="stockpricediv" colSpan="2" >
                                <div >
                                    <table className="stockpricetable" >
                                        <tbody>
                                            <tr>
                                                <td className="col1">
                                                    {this.formatNumber(tradeprice, 1)}
                                                </td>
                                                <td className="col3">
                                                    {this.millisToHoursAndMinutes(tradetime)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className={"col2" + (change>0?" positive":(change<0?" negative":""))}>
                                                    {(change>0?"+":"")+this.formatNumber(change, 1)} ({(change>0?"+":"")+this.formatPercentage(pctchange/100)})
                                                </td>
                                                <td>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan="3">
                                                    <div>
                                                    <HighchartsReact highcharts={Highcharts} options={this.state.chartoptions_rating} containerProps = {{ className: this.props.type==="0"?"":"hidden" }}/>
                                                    <HighchartsReact highcharts={Highcharts} options={this.state.chartoptions_estimate} containerProps = {{ className: this.props.type==="0"?"hidden":"" }}/>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </td>
                            <td>
                                <div className="dataTableDiv">
                                    <table className="dataTable">
                                        <tbody>
                                            <tr>
                                                <th>{this.tabletitle[this.props.type][0]}</th>
                                                <th className="th_right"><div dangerouslySetInnerHTML={{__html: this.tabletitle[this.props.type][1]}} /></th>
                                            </tr>
                                            { this.genDataRow() }
                                        </tbody>
                                    </table>
                                </div>
                            </td>
                        </tr>
                        <tr>
                        </tr>
                    </tbody>
                </table>	
            </div>
        )
    };
}